export default __webpack_public_path__ + "static/media/hero.53b84854.png";